import { HtmlDiv } from 'htmlmodule'

export class Inner extends HtmlDiv
{
  static class = 'Inner'
}
